import type { QuotingProspect } from 'utils/web_api.schemas'

import { getFormattedDate } from '../../utils'
import { SkeletonItem } from '../reusable/SkeletonItem'

export function BrokerProspectInfo ({
  prospect,
  showEIN,
  showOwnerEmail: _showOwnerEmail,
}: {
  prospect?: QuotingProspect | null;
  showEIN?: boolean;
  showOwnerEmail?: boolean;
}) {
  return (
    <div className='flex justify-between items-center p-4 bg-white rounded-lg border border-thatch-gray-border'>
      <dl className='flex gap-x-8 text-sm text-ds-text-default'>
        <div className='flex flex-col'>
          <dt className='font-semibold'>Prospect Email</dt>
          <dd>{prospect ? prospect.email : <SkeletonItem />}</dd>
        </div>
        <div className='flex flex-col'>
          <dt className='font-semibold'>Date created</dt>
          <dd>
            {prospect
              ? (
                  getFormattedDate(prospect.created_at)
                )
              : (
                <SkeletonItem />
                )}
          </dd>
        </div>
        {showEIN && (
          <div className='flex flex-col'>
            <dt className='font-semibold'>EIN</dt>
            <dd>{prospect ? (prospect.ein ?? '—') : <SkeletonItem />}</dd>
          </div>
        )}
      </dl>
    </div>
  )
}
